import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { doctorInfo } from "../mockData";
import { Card, CardContent } from "./ui/card";

const Contact = () => {
  const contactInfo = [
    {
      icon: MapPin,
      title: "Address",
      content: doctorInfo.address,
      link: null,
    },
    {
      icon: Phone,
      title: "Phone",
      content: doctorInfo.phone,
      link: `tel:${doctorInfo.phone}`,
    },
    {
      icon: Mail,
      title: "Email",
      content: doctorInfo.email,
      link: `mailto:${doctorInfo.email}`,
    },
    {
      icon: Clock,
      title: "Office Hours",
      content: "Mon-Fri: 9:00 AM - 5:00 PM",
      link: null,
    },
  ];

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">
            Get In Touch
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mt-2">
            Contact Information
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Reach out to us for appointments, inquiries, or any healthcare
            concerns
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {contactInfo.map((item, index) => {
            const IconComponent = item.icon;
            const content = item.link ? (
              <a
                href={item.link}
                className="text-blue-600 hover:text-blue-700 transition-colors duration-200"
              >
                {item.content}
              </a>
            ) : (
              <span className="text-gray-700">{item.content}</span>
            );

            return (
              <Card
                key={index}
                className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <CardContent className="p-6 text-center space-y-4">
                  <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto">
                    <IconComponent className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">
                      {item.title}
                    </h3>
                    <div className="text-sm">{content}</div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Map */}
        <div className="bg-gray-300 rounded-lg overflow-hidden shadow-xl h-96 flex items-center justify-center">
          <iframe
            src={doctorInfo.locationEmbed}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Hospital Location"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;
